import React, { useState } from 'react'
import styled from 'styled-components';
import RightNav from './RightNav';

const StyledBurger = styled.div`
    height: clamp(1.5rem, 7vw, 3rem);
    z-index: 20;
    display: none;
    cursor: pointer;

    @media (max-width: 1450px) {
        display: flex;
        justify-content: space-around;
        flex-flow: column nowrap;
    }

    div {
        width: clamp(1.8rem, 7vw, 3rem);
        height: clamp(0.1rem, 2vw, 0.4rem);
        background-color: ${({ open }) => open ? 'white' : '#8a8affff'};
        border-radius: 10px;
        transform-origin: 1px;
        transition: all 0.3s linear;

        &:nth-child(1) {
            transform: ${({ open }) => open ? 'rotate(45deg)' : 'rotate(0)'};
        }

        &:nth-child(2) {
            transform: ${({ open }) => open ? 'translateX(100%)' : 'translateX(0)'};
            opacity: ${({ open }) => open ? 0 : 1};
        }

        &:nth-child(3) {
            transform: ${({ open }) => open ? 'rotate(-45deg)' : 'rotate(0)'};
        }
    }
`;

const Burger = () => {
  const [open, setOpen] = useState(false)

  return (
    <>

        <StyledBurger open={open} onClick={() => setOpen(!open)}>

            <div />
            <div />
            <div />

        </StyledBurger>
        
        <RightNav open={open} setOpen={setOpen} />

    </>
  )
}

export default Burger;
